import { Component, OnInit } from '@angular/core';
/*import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService, ExpenseService } from '@app/core';
import { Expense } from '@core/model/expense.model';
import { error } from 'selenium-webdriver';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';*/

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.css']
})
export class ExpenseComponent implements OnInit {
  // expenses: Expense[];
  // expenseForm: FormGroup;
  // currentUserSubscription: Subscription;
  // user_id: number;

  constructor() {
    /* this.currentUserSubscription = this.authService.currentUser.subscribe(
      user => {
        // console.log(data.data.user.id);
        this.user_id = user.data.user.id;
        // this.username = this.currentUser.data.user.username;
      }
    );*/
  }

  ngOnInit() {
    // this.createForm();
    // this.listExpenses();
  }

  /*  listExpenses() {
    this.expenseService.getAll().subscribe(
      data => {
        this.expenses = data;
        // console.log(data);
      },
      error1 => {
        console.log(error1);
      }
    );
  }*/

  /*createForm() {
    this.expenseForm = this.formBuilder.group({
      monto: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }*/

  /* registerExpense() {
    console.log(this.expenseForm.value.monto);
    const newExpense = new Expense();
    newExpense.monto = this.expenseForm.value.monto;
    newExpense.descripcion = this.expenseForm.value.descripcion;
    newExpense.user_id = this.user_id;

    this.expenseService.create(newExpense).subscribe(
      data => {
        Swal.fire(data);
        this.listExpenses();
      },
      error1 => {
        console.log(error1);
        Swal.fire(error1.error);
      }
    );
  }*/
}
